<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container
            class="fluid grid-list-xl"
            style="height: 100%;"
    >
        <v-layout class="row wrap">
            <!--            <v-text-field-->
            <!--                    v-model="search"-->
            <!--                    append-icon="search"-->
            <!--                    label="Search"-->
            <!--                    single-line-->
            <!--                    hide-details-->
            <!--            ></v-text-field>-->
            <v-flex class="xs12 sm6 md9 lg9" style="padding-top:0px; padding-bottom: 0px; ">
                <span style="font-weight: bold; font-size: 17px;">계정 관리</span>
            </v-flex>
            <v-flex class="xs9 offset-xs3 sm6 offset-sm6 md3 offset-md0" style="padding-top: 0px; padding-bottom: 0px;">
                <v-text-field
                        placeholder="search"
                        solo
                        v-model="search"
                        prepend-inner-icon="search"
                        label="Search"
                        clearable
                        class="ma-0 hide-messages"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout class="row wrap">
            <v-flex class="xs12 sm12 md12">
                <v-data-table
                        :headers="headers"
                        :items="accounts"
                        :search="search"
                        hide-actions
                        class="elevation-1"
                >
                    <template slot="items" slot-scope="items">
                        <td class="text-xs-center">{{ items.item.Username }}</td>
                        <td class="text-xs-center">{{ items.item.Description }}</td>
                        <td class="text-xs-center" style="width: 310px;">
                            <v-btn color="success" style="width: 100px;" @click="account_dialog_passwordreset(items.item)">비밀번호 초기화</v-btn>
                            <v-btn color="success" style="width: 80px;" @click="
                                    dialog_change = true;
                                    dialog_change_item = tool_app.copy(items.item);
                            ">수정</v-btn>
                            <v-btn color="success" style="width: 80px;" @click="account_delete(items.item)">삭제</v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>

        <v-btn class="v-btn v-btn--floating v-btn--bottom v-btn--fixed v-btn--right pink" round style="width: 60px; height: 60px; margin-right:15px; "
               @click="
               account_dialog_new = true;
               account_id = '';
               account_password = '';
               account_description = '';
               account_dialog = true;
               ">
            <v-icon>add</v-icon>
        </v-btn>

        <v-dialog v-model="account_dialog" persistent max-width="400px">
            <v-card>
                <v-card-text>
                    <span style="font-weight: bold; font-size: 17px;">계정 생성</span>
                    <v-container grid-list-md>
                        <v-form
                                ref="form"
                                v-model="account_valid"
                                lazy-validation
                        >
                            <v-layout wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="ID*" v-model="account_id"
                                                  :rules="account_id_rules"
                                                  :disabled="account_dialog_new === false"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 v-show="account_dialog_new === true">
                                    <v-text-field label="Password*" type="password" v-model="account_password"
                                                  :rules="account_password_rules"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="비고" v-model="account_description"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="account_dialog = false">Close</v-btn>
                    <v-btn color="blue darken-1" flat @click="account_submit()">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="account_dialog_changepassword" persistent max-width="400px">
            <v-card>
                <v-card-text>
                    <span style="font-weight: bold; font-size: 17px;">비밀번호 변경</span>
                    <v-container grid-list-md>
                        <v-form
                                ref="account_dialog_changepassword_form"
                                v-model="account_dialog_changepassword_valid"
                                lazy-validation
                        >
                            <v-layout wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="ID*" v-model="account_dialog_changepassword_item.Username"
                                                  :rules="account_id_rules"
                                                  :disabled="true"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="Password*" type="password" v-model="account_dialog_changepassword_password"
                                                  :rules="account_password_rules"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="account_dialog_changepassword = false">Close</v-btn>
                    <v-btn color="blue darken-1" flat @click="account_dialog_changepassword_submit()">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="dialog_change" persistent max-width="400px">
            <v-card>
                <v-card-text>
                    <v-container grid-list-md>
                        <span style="font-weight: bold; font-size: 17px;">계정 수정</span>
                        <v-form
                                ref="dialog_change_form"
                                v-model="dialog_change_valid"
                                lazy-validation
                        >
                            <v-layout wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="ID*" v-model="dialog_change_item.Username"
                                                  :disabled="true"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="비고" v-model="dialog_change_item.Description"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="dialog_change = false">Close</v-btn>
                    <v-btn color="blue darken-1" flat @click="dialog_change_submit()">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>

<script>
    import StatsCard from '../components/material/StatsCard';
    import Test from '../components/core/Test';
    import UserButton from '../components/core/UserButton';
    import tool_app from '../utils/tool_app';
    import tool_aws from '../utils/tool_aws';
    import awsmobile from '../aws-exports';
    import {Auth,} from 'aws-amplify';

    function lg (...args) { tool_app.lg('AccountManage] ', ...args); }

    let comp = null;
    export default {
        components: {UserButton, Test, StatsCard,},
        data () {
            return {
                account_dialog: false,
                account_dialog_new: false,
                account_valid: true,
                account_id: '',
                account_id_rules: [
                    v => !!v || '3자 이상 입력해주세요..',
                    v => v.length >= 3 || '3자 이상 입력해주세요..'
                ],
                account_password: '',
                account_password_rules: [
                    v => v.length >= 6 || '6자 이상 입력해주세요..'
                ],
                account_description: '',

                account_dialog_changepassword: false,
                account_dialog_changepassword_valid: true,
                account_dialog_changepassword_item: { Username:'' },
                account_dialog_changepassword_password: '',

                dialog_change: false,
                dialog_change_valid: true,
                dialog_change_item: {},

                search: '',
                accounts: [
                    // {
                    //   ListadoProducto: {
                    //     id: 5,
                    //     lim_exc: 5000,
                    //     lim_falt: 200,
                    //     nombre: 'Algo',
                    //     precio: 300
                    //   },
                    //   ListadoProductoId: 5,
                    //   disponible: 100,
                    //   id: 5
                    // },
                    // {
                    //   ListadoProducto: {
                    //     id: 6,
                    //     lim_exc: 1000,
                    //     lim_falt: 200,
                    //     nombre: 'Bgo',
                    //     precio: 450
                    //   },
                    //   ListadoProductoId: 6,
                    //   disponible: 0,
                    //   id: 6
                    // }
                ],

                headers: [
                    {text: 'ID', value: 'Username', align:'center', },
                    {text: '비고', value: 'Attribute_permission', align:'center',},
                    {text: '', value: '', sortable: false, align:'center', },
                ],
            }
        },
        created: function () {
            comp = tool_app.initComp(this);
            comp.getList();
            if(tool_app.isAdmin() === false) {
                comp.$router.replace('/');
            }

            // You can get the current config object
            const currentConfig = Auth.configure();
            lg('Auth currentConfig:', currentConfig);
        },
        methods: {
            async account_submit () {
                lg('account_submit 1 this.account_dialog_new:', comp.account_dialog_new);
                if (comp.account_dialog && comp.$refs.form.validate()) {
                    // TODO 권한, 관리지점 필드에 대한 validation 코드 필요함
                    // TODO 총괄관리자의 경우에는 관리지점이 비어있어야 함
                    if(comp.account_permission === '총괄관리자') {
                        comp.account_manage_parkinglot = 0;
                    }
                    lg('validate 2 this.account_id:', comp.account_id);
                    lg('validate 2 this.account_password:', comp.account_password);
                    lg('validate 2 this.account_permission:', comp.account_permission);
                    lg('validate 2 this.account_manage_parkinglot:', comp.account_manage_parkinglot);

                    tool_app.dialog_progress_show(comp);
                    let cognito = await tool_aws.getAdminCognito();
                    let params = {
                        ClientId: awsmobile.aws_user_pools_web_client_id, /* required */
                        Password: comp.account_password, /* required */
                        Username: comp.account_id, /* required */
                        UserAttributes: [ /* required */
                          {
                            Name: 'custom:description', /* required */
                            Value: comp.account_description,
                          },
                        ],
                    };
                    cognito.signUp(params, (err, data) => {
                        if (err) {
                            tool_app.dialog_progress_hide(comp);
                            this.$dialog.alert(JSON.stringify(err, null, 2));
                            return;
                        }
                        lg('dialog_change_submit 2 data: ', data);

                        comp.account_dialog = false;
                        comp.getList();
                        tool_app.dialog_progress_hide(comp);
                    });
                }
            },
            async account_dialog_changepassword_submit() {
                lg('account_dialog_changepassword_submit 1 ');
                if (this.account_dialog_changepassword && this.$refs.account_dialog_changepassword_form.validate()) {
                    tool_app.dialog_progress_show(comp);
                    let cognito = await tool_aws.getAdminCognito();
                    let params = {
                        UserPoolId: awsmobile.aws_user_pools_id,
                        Username: this.account_dialog_changepassword_item.Username,
                        Password: this.account_dialog_changepassword_password,
                        Permanent: true,
                    };
                    cognito.adminSetUserPassword(params, (err, data) => {
                        if(err) {
                            tool_app.ex(err);
                            return;
                        }
                        tool_app.lg('account_dialog_changepassword_submit 2 response:', JSON.stringify(data, null, 2));
                        comp.account_dialog_changepassword = false;
                        tool_app.dialog_progress_hide(comp);
                    });
                }
            },
            async account_dialog_passwordreset(item) {
                lg('account_dialog_passwordreset 1 ');
                let d = comp.$dialog.confirm(item.Username + '의 비밀번호를 초기화 하시겠습니까?');
                d.then(async (dialog) => {
                    tool_app.dialog_progress_show(comp);
                    let cognito = await tool_aws.getAdminCognito();
                    let params = {
                        UserPoolId: awsmobile.aws_user_pools_id,
                        Username: item.Username,
                        Password: '111111',
                        Permanent: false,
                    };
                    cognito.adminSetUserPassword(params, (err, data) => {
                        if(err) {
                            tool_app.ex(err);
                            return;
                        }
                        tool_app.lg('account_dialog_passwordreset 2 response:', JSON.stringify(data, null, 2));
                        tool_app.dialog_progress_hide(comp);
                    });
                });

            },
            async account_delete(item) {
                lg('account_delete 1 ', item);
                this.$dialog.confirm(item.Username + '을 정말 삭제하시겠습니까?')
                    .then(async (dialog) => {
                        lg('account_delete confirm');
                        let cognito = await tool_aws.getAdminCognito();
                        let params = {
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: item.Username,
                        };
                        cognito.adminDeleteUser(params, (err, data) => {
                            if(err) {
                                tool_app.ex(err);
                                return;
                            }
                            lg('account_delete 2 response:', JSON.stringify(data, null, 2));
                            comp.getList();
                            comp.$dialog.alert('삭제가 완료되었습니다.');
                        });
                    });
            },
            async dialog_change_submit() {
                lg('dialog_change_submit 1 ');
                if (comp.dialog_change && comp.$refs.dialog_change_form.validate()) {
                    // TODO 권한, 관리지점 필드에 대한 validation 코드 필요함
                    // TODO 총괄관리자의 경우에는 관리지점이 비어있어야 함
                    if(comp.dialog_change_permission === '총괄관리자') {
                        comp.dialog_change_parkinglot = 0;
                    }
                    // lg('dialog_change_submit 2 this.account_id:', this.account_id)
                    // lg('validate 2 this.account_password:', this.account_password)
                    // lg('validate 2 this.account_permission:', this.account_permission)
                    // lg('validate 2 this.account_manage_parkinglot:', this.account_manage_parkinglot)
                    // lg('validate 2 this.account_manage_parkinglot:', this.account_manage_parkinglot)

                    lg('dialog_change_submit 2 this.dialog_change_parkinglot:', comp.dialog_change_parkinglot);
                    tool_app.dialog_progress_show(comp);

                    let cognito = await tool_aws.getAdminCognito();
                    let params = {
                        UserAttributes: [ /* required */
                            {
                                Name: 'custom:description', /* required */
                                Value: comp.dialog_change_item.Description,
                            },
                        ],
                        UserPoolId: awsmobile.aws_user_pools_id, /* required */
                        Username: comp.dialog_change_item.Username /* required */
                    };
                    cognito.adminUpdateUserAttributes(params, (err, data) => {
                        if (err) {
                            tool_app.dialog_progress_hide(comp);
                            comp.$dialog.alert(JSON.stringify(err, null, 2));
                            return;
                        }
                        // this.dialog_change = false
                        // tool_app.dialog_progress_hide(this)
                        // lg('dialog_change_submit 2 data: ', data);
                        // tool_app.api(comp, '' +
                        //     'UPDATE T_Account \n' +
                        //     '   SET Permission = ?, \n' +
                        //     '       ParkingLotUUID_Managing = ?, \n' +
                        //     '       DateTime_Modified = NOW() \n' +
                        //     ' WHERE ID = ?', [
                        //     comp.dialog_change_permission,
                        //     comp.dialog_change_parkinglot,
                        //     comp.dialog_change_id,
                        // ])
                        // // .setShowProgressDialog()
                        //     .send()
                        //     .then((response) => {
                        //         comp.dialog_change = false;
                        //         if (response.data.error) {
                        //             tool_app.dialog_progress_hide(comp);
                        //             comp.$dialog.alert(JSON.stringify(response.data.error, null, 2))
                        //             return;
                        //         }
                        //         tool_app.dialog_progress_hide(comp);
                        //         lg('tableData: response: ', response);
                        //         comp.getList();
                        //     })

                        lg('tableData: data: ', data);
                        comp.dialog_change = false;
                        tool_app.dialog_progress_hide(comp);
                        comp.getList();
                    });
                }
            },
            async getList() {
                lg('getList 1 ');
                let cognito = await tool_aws.getAdminCognito();
                let params = {
                    UserPoolId: awsmobile.aws_user_pools_id,
                    // AttributesToGet: [
                    //   'STRING_VALUE',
                    // ],
                    // Filter: 'STRING_VALUE',
                    // Limit: 'NUMBER_VALUE',
                    // PaginationToken: 'STRING_VALUE'
                };
                cognito.listUsers(params, (err, data) => {
                    if(err) {
                        tool_app.ex(err);
                        return;
                    }
                    lg('getList 2 data:', data);
                    data.Users.forEach((value, index) => {
                        let a = value.Attributes.find(function(element) {
                            // lg('getList 4 element:', element);
                            if(element) {
                                return element.Name === 'custom:description';
                            }
                        });
                        if(a) {
                            value.Description = a.Value;
                        }
                    });
                    comp.accounts = data.Users;
                });
            },
        }
    }
</script>
